import React, { useState, useEffect } from 'react';
import ChatInterface from '../components/ChatInterface';
import api from '../services/api';
import './ChatPage.css';

function ChatPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  // Check for existing token on mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const data = await api.login(username, password);
      localStorage.setItem('token', data.access_token);
      setIsAuthenticated(true);
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.message || 'Identifiants incorrects';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (password.length < 4) {
      setError('Le mot de passe doit contenir au moins 4 caractères');
      return;
    }

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    setLoading(true);

    try {
      await api.register(username, password);
      setSuccess('Compte créé avec succès! Vous pouvez maintenant vous connecter.');
      setIsRegisterMode(false);
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.message || 'Erreur lors de la création du compte';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    // Clear token
    localStorage.removeItem('token');
    // Clear chat messages and session from localStorage to prevent next user from seeing them
    localStorage.removeItem('chat_messages');
    localStorage.removeItem('chat_session_id');
    setIsAuthenticated(false);
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setSuccess('');
  };

  const toggleMode = () => {
    setIsRegisterMode(!isRegisterMode);
    setError('');
    setSuccess('');
    setPassword('');
    setConfirmPassword('');
  };

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2>{isRegisterMode ? 'Créer un compte' : 'Connexion Patient'}</h2>

          {success && <div className="success-message">{success}</div>}
          {error && <div className="error-message">{error}</div>}

          <form onSubmit={isRegisterMode ? handleRegister : handleLogin}>
            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete={isRegisterMode ? "new-password" : "current-password"}
              />
            </div>
            {isRegisterMode && (
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary">
              {loading
                ? (isRegisterMode ? 'Création...' : 'Connexion...')
                : (isRegisterMode ? 'Créer un compte' : 'Se connecter')
              }
            </button>
          </form>

          <div className="toggle-mode">
            {isRegisterMode ? (
              <>
                Vous avez déjà un compte?{' '}
                <button onClick={toggleMode} className="link-btn">
                  Se connecter
                </button>
              </>
            ) : (
              <>
                Pas encore de compte?{' '}
                <button onClick={toggleMode} className="link-btn">
                  Créer un compte
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-page">
      <div className="chat-header">
        <h2>Session de Chat</h2>
        <button onClick={handleLogout} className="btn-secondary">
          Deconnexion
        </button>
      </div>
      <ChatInterface />
    </div>
  );
}

export default ChatPage;
